//fr.js
export default {
  pc: {
    homepage: {
      //Navigation: use sub section’s titles. 
    },
    aboutus: {
      title: 'À&nbsppropos&nbspde&nbspnous', /*'À propos de nous',*/
      title1: 'COTE est un magazine haut de gamme et un opérateur de luxe suisse. ',
      desc1: 'Depuis plus de 20 ans, il s’est engagé à définir et à interpréter de «nouveaux modes de vie de haute qualité» sur la base de son rôle de citoyen suisse et de magazine contemporain. ',
      title2: 'COTE est unique dans le monde du luxe. ',
      desc2: 'Sa mission de marque est de défendre la valeur des citoyens et des entreprises qui recherchent une qualité de vie haut de gamme dans la vie quotidienne et de faire en sorte que cette valeur soit pleinement incarnée.',
      title3: 'COTE Concierge',
      desc3: 'fournit le service de conciergerie privé haut de gamme sous la marque COTE. Nous personnaliserons des services plus réfléchis et méticuleux pour les clients commerciaux et privés en fonction de leurs demandes uniques.',

    },
    flagshipservices: {
      title: 'Services Phares',
      //subtitle: common.coteconcierge
      // titleimageurl: '../../assets/img/cote/mobile/tu-07-compress.jpg', 

      title1: '1. Services aux employés',
      desc1: "Services de bien-être pour les employés (Massages, Soins capillaires et esthétiques, etc.)Services voiture (Nettoyage voiture, Changement de pneu, etc.)Services postaux et colis personnelsService d'accueil (Viennoiseries, Corbeille de fruits, Fleur, etc.)Sécurité / Garde du corps",
      title2: "2. Voyages d'affaires",
      desc2: "Réservation d'hôtels Transport (Vols, Billets de train, Réservation de taxis, etc.)Planification et gestion des réunions Assistant personnel Chauffeur",
      title3: '3. Événements',
      desc3: "Événements corporatifs / institutionnels Organisation de conférences et congrès Service de restauration Consolidation d'équipe",
      title4: '4. Privilèges exclusifs',
      desc4: "De plus, grâce à notre réseau privilégié de relations avec de nombreux acteurs majeurs de l'économie de la région, vous pourrez profiter d'expériences exclusives : assistance personnelle lors de vos achats, visites de manufactures horlogères et maisons de couture, repas avec des PDG, ouvertures privées de boutiques, places VIP et box privés lors de défilés…",

    },

    privateclient: {
      title: 'Clients&nbspPrivés',
      desc1: 'Hôtels de luxe',
      desc2: 'Limousine',
      desc3: 'Jet privé / Yachting',
      desc4: 'Réservation de restaurants Michelin',
      desc5: 'Achats sur mesure',
      desc6: 'Anti-âge / Soins de la peau / Amincissement / Clinique beauté / Massage / SPA',
      desc7: 'Location & Vente de biens immobiliers',
      // desc8: '',
      desc9: "Planification de vacances en famille / Fêtes privées / Fêtes d'anniversaire",
      desc10: '',
      desc11: 'Entretien ménager',
      desc12: '(Chef / Jardinage / Chauffeur / Garde du corps / Médecin de famille, etc.)',
      desc13: 'Au jour le jour',
      desc14: '(Épicerie / Services postaux / Réparation et entretien / Animal de compagnie, etc.)',
      desc15: 'Éducation',
      desc16: '(École privée / Coach sportif / Étude des langues, etc.)',

    },

    contactus: {
      title: 'Contactez-nous',
      desc: '',
      address: 'Adresse : ',
      phonenumber: 'N° de tél.:',
      email: 'Email :',
      website: 'Site web : ', //no need to show
      officehours: "Heures d'ouverture : Lundi-Vendredi 06:00 - 18:00",

      //sub title: common.coteconcierge
      messageboard: {
        firstname: 'Prénom*',
        lastname: 'Nom*',
        email: 'Email*',
        phonenumber: 'N° de tél',
        messagecontent: 'Message*',
        send: 'Envoyer',
        length_errmsg: "Pas plus de {count} caractères.",
        //"Pas plus de {count} caractères, s'il vous plaît.",
        //调用的地方：$tc('length_errmsg', x)
        firstname_errmsg: 'Veuillez saisir votre prénom.',
        lastname_errmsg: 'Veuillez saisir votre nom de famille.',
        email_errmsg: 'Veuillez saisir votre courriel.',
        email_errmsg2: 'Le format du courriel est incorrect.',
        phonenumber_errmsg: '',
        messagecontent_errmsg: 'Veuillez saisir un message.',
        // $tc('length_errmsg', 1000)
        messagecontent_errmsg2: 'Le message ne doit pas dépasser {count} mots, veuillez vérifier.',
        send_errmsg: 'La soumission du formulaire a échoué, veuillez vérifier les informations saisies et réessayer.',
        send_errmsgwithdetails: "La soumission du formulaire a échoué, veuillez vérifier les informations saisies et réessayer. Détails de l'erreur: {details}",
        //$tc('send_errmsgwithdetails', errordetails)
        send_errmsg2: "La soumission du formulaire a échoué en raison d'une erreur du système. Veuillez bien vouloir contacter l'administrateur pour vérifier.",
        send_sucessmsg: 'Formulaire soumis avec succès. Merci!',
      },
    },
    common: {
      coteconcierge: 'Cote Concierge',
      services: 'Services',
      contact: 'Contact',
    },
  }
}